import { z } from 'zod'
import { oc } from '@orpc/contract'

// Pins or unpins a Frequently used recipient by the key the frequent list returned.
export const referralDiscoveryBookmarkInputSchema = z.object({
  key: z.string().min(1).max(400),
  bookmarked: z.boolean(),
})

export const referralDiscoveryBookmark = oc
  .route({ method: 'POST', path: '/v2/referral-discovery/bookmark' })
  .input(referralDiscoveryBookmarkInputSchema)
  .output(z.object({ ok: z.literal(true) }))
